export const typeTagOption = [
	{
		name: 'Apply organization´s tags',
		value: 'organization_tag'
	},
	{
		name: 'Use CSV´s tags',
		value: 'csv_tag'
	}
]
